import { jsx as o, Fragment as c, jsxs as m } from "react/jsx-runtime";
import { useCallback as g } from "react";
import { MenuItem as p } from "../menu-item/index.js";
import t from "./styles.module.less.js";
import { DropdownMenuItemMobile as u } from "../dropdown-menu-item/index.js";
import w from "./billing-history.svg.js";
import d from "./world.svg.js";
const I = (s) => {
  const { getTranslation: e, language: r, isScrolledHeader: n, isActive: a } = s, i = g(() => {
    window.location.href = `/${r}/for-lawyers/legal-network`;
  }, [r]);
  return /* @__PURE__ */ o(
    p,
    {
      label: e("register.for-lawyers"),
      chevronStyle: "rotate",
      hasShrunk: n,
      isActive: a,
      onClick: i,
      classNames: {
        wrapper: t.buttonWrapper,
        childContainer: `${t.hoverMenu} ${n ? t.scrolledHeader : ""}`
      },
      children: /* @__PURE__ */ o(c, { children: [
        {
          path: `/${r}/for-lawyers/legal-network`,
          title: e("about.menu.legal-network"),
          icon: /* @__PURE__ */ o(d, { className: t.menuIcon })
        },
        {
          path: `/${r}/for-lawyers/register-interest`,
          title: e("pages.register-interest"),
          icon: /* @__PURE__ */ o(w, { className: t.menuIcon })
        }
      ].map((l) => /* @__PURE__ */ m("a", { href: l.path, className: t.menuItem, children: [
        /* @__PURE__ */ o("span", { className: `${t.menuItemText}`, children: l.title }),
        l.icon
      ] }, l.title)) })
    }
  );
}, N = (s) => {
  const { getTranslation: e, language: r, classNames: n } = s;
  return /* @__PURE__ */ o(
    u,
    {
      language: r,
      titleLabel: e("register.for-lawyers"),
      link: `/${r}/for-lawyers/legal-network`,
      items: [
        {
          title: e("about.menu.legal-network"),
          description: e("register.legal-network-description"),
          path: `/${r}/for-lawyers/legal-network`
        },
        {
          title: e("pages.register-interest"),
          description: e("register.register-interest-description"),
          path: `/${r}/for-lawyers/register-interest`
        }
      ],
      classNames: n
    }
  );
};
export {
  I as ForLawyersMenuButtonDesktop,
  N as ForLawyersMenuButtonMobile
};
